import React, { useEffect, useState } from "react";
import "./buttonGroup.scss";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TButtonGroupButton = {
    key: string | number;
    label: string | React.ReactNode;
    icon?: IconDefinition;
};

interface IProps {
    buttons: Array<TButtonGroupButton>;
    onButtonClick?: (key: string | number) => void;
    startKey?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    noSelection?: boolean;
}

export default function ButtonGroup(props: IProps) {
    const { buttons, onButtonClick, startKey, fullWidth, noSelection, disabled } = props;
    const [activeButton, setActiveButton] = useState<string | number>(startKey ? startKey : buttons[0]?.key ?? "");

    useEffect(() => {
        if (startKey) {
            setActiveButton(startKey);
        }
    }, [startKey]);

    function handleButtonClick(key: string | number) {
        if (disabled) {
            return;
        }
        
        if (!noSelection) {
            setActiveButton(key);
        }

        if (onButtonClick) {
            void onButtonClick(key);
        }
    }

    return (
        <div className="ui-buttons-group">
            {buttons?.map((button, index) => (
                <div
                    key={index}
                    className={`ui-buttons-group-button ${activeButton === button.key ? "ui-buttons-group-button-active" : ""
                        } ${fullWidth ? "w-100" : ""} ${disabled ? "ui-buttons-group-button-disabled" : ""}`}
                    onClick={() => handleButtonClick(button.key)}
                >
                    {button?.icon ? <FontAwesomeIcon icon={button?.icon} className="mr-2" /> : null} {button?.label}
                </div>
            ))}
        </div>
    );
}